import type React from 'react';
import { VendorLayoutV2 } from '~/components/common/layouts/VendorLayoutV2';
import { VendorSettingLayout } from '~/components/common/layouts/settings/VendorSettingLayout';
import { ProfileSetting } from '~/components/specifics/vendors/settings/profiles/ProfileSetting';
import { AccountSetting } from '~/components/specifics/vendors/settings/accounts/AccountSetting';
import { useSessions } from '~/hooks/vendors/useSessions';

export const Page: React.FC = () => {
  const { data: session } = useSessions().index();
  return (
    <VendorLayoutV2>
      <VendorSettingLayout spMenu>
        {session !== null && session.admin ? (
          <AccountSetting />
        ) : (
          <ProfileSetting />
        )}
      </VendorSettingLayout>
    </VendorLayoutV2>
  );
};
